// Central contact + brand configuration. Update these with real details anytime.
// NOTE: SITE_URL is derived automatically from the live domain (no hardcoding),
// so JSON-LD / structured data always use the correct production URL.
export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");

export const SITE = {
  name: "TripTrix Voyages",
  tagline: "B2B Himalayan Destination Management Company",
  b2bNote:
    "TripTrix Voyages is a B2B-only DMC — we work exclusively with travel agents & tour operators, not direct travellers.",
  phoneDisplay: "+91 62396 80670",
  phoneRaw: "+916239680670",
  whatsappRaw: "916239680670",
  email: "triptrixvoyages@gmail.com",
  addressLine: "Head Office: Siliguri · Branch: Guwahati",
  offices: [
    {
      label: "Head Office",
      city: "Siliguri",
      lines: ["Mars Mansion, First Floor", "Shiv Mandir, Siliguri", "West Bengal"],
    },
    {
      label: "Branch Office",
      city: "Guwahati",
      lines: ["Paltan Bazar, Gali No. 1", "Second Floor, Guwahati", "Assam"],
    },
  ],
  established: "Est. 2016",
  gst: "07JDEPS7936H1ZV",
  msme: "Udyam Registered (MSME)",
  partnerCount: "250+",
  rating: "4.9/5",
  parentCompany: "Vedic Destination",
  parentNote: "A unit of Vedic Destination",
  founderLinkedin: "https://www.linkedin.com/in/satyam-singh-2a84251a0",
  socials: {
    instagram: "https://www.instagram.com/triptrixvoyages_",
    facebook: "",
    linkedin: "https://www.linkedin.com/in/satyam-singh-2a84251a0",
    youtube: "",
  },
};

export const waLink = (msg = "Hello TripTrix Voyages, I'd like to plan a trip.") =>
  `https://wa.me/${SITE.whatsappRaw}?text=${encodeURIComponent(msg)}`;

// Responsive srcset for Unsplash/Pexels CDN images — the SAME photo, right-sized
// per device (phones pull the small variant; major LCP win on mobile).
export const imgSrcSet = (url, widths = [640, 1080, 1600, 2100]) => {
  if (!url || typeof url !== "string") return undefined;
  if (!/images\.(unsplash|pexels)\.com/.test(url)) return undefined;
  const base = url.replace(/([?&])(w|h|q|dpr)=[^&]*/g, "").replace(/[?&]$/, "");
  const sep = base.includes("?") ? "&" : "?";
  return widths.map((w) => `${base}${sep}q=62&auto=format&w=${w} ${w}w`).join(", ");
};

// Real photos from our North East operations offices (E-E-A-T trust signals).
// Self-hosted on our own domain (WebP, visually identical to the originals).
export const OFFICE_HERO = "/assets/office/office-hero.webp";
export const OFFICE_PHOTOS = [
  { src: "/assets/office/office-1.webp", alt: "TripTrix Voyages operations floor — North East India DMC" },
  { src: "/assets/office/office-2.webp", alt: "The TripTrix trade & ground-ops desk at work" },
  { src: "/assets/office/office-3.webp", alt: "Reception — a unit of Vedic Destination" },
  { src: "/assets/office/office-4.webp", alt: "Planning journeys for our travel-agent partners" },
  { src: "/assets/office/office-5.webp", alt: "Inside our North East operations office" },
  { src: "/assets/office/office-6.webp", alt: "Our on-ground operations team" },
];
